import { render, staticRenderFns } from "./PageMultisig.vue?vue&type=template&id=3a3b16ec"
import script from "./PageMultisig.vue?vue&type=script&lang=js"
export * from "./PageMultisig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports